import {
	Box as BoxMui,
} from '@mui/material';
import { ChildrenProps, DisplayTypes, JustifyContentTypes, LiteralStringOrArrayOfLiteralStrings, appendClassName } from '@componentLibraryWrapper/common';
import './box.scss';

export interface BoxProps extends ChildrenProps<HTMLDivElement> {
	justifyContent?: LiteralStringOrArrayOfLiteralStrings<JustifyContentTypes>,
	display?: LiteralStringOrArrayOfLiteralStrings<DisplayTypes>
}

const Box = ({
	className,
	...rest
}: BoxProps) => {
	return (
		<BoxMui 
			{...rest}
			className={appendClassName('sm-box', className)}/>
	)
}

export default Box;